export default {
    totalEmployee: 'พนักงานทั้งหมด',
    checkInOnTime: 'เข้างานตรงเวลา',
    late: 'มาสาย',
    absent: 'ขาด',
    onstie: 'นอกสถานที่',
    leave: 'ลา'
}
